import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ReviewDetailsService {

  constructor(public http:HttpClient) { }
  public getDasFormDetails(): Observable<any>{
    return this.http.get(environment.BASE_URL_PUCA+'das/getInitFormData')
  }

  public saveApplicationData(payload):Observable<any>{
    return this.http.post(environment.BASE_URL_PUCA+'das/saveApplicationDataAndSubmit',payload)
  }

  public submitReviseApplicationData (payload):Observable<any>{
    return this.http.post(environment.BASE_URL_PUCA+'das/submitReviseApplicationData',payload)
  }
  
}
